export const RoleNames = {
    ERT_USER: "ERT_User",
    ERT_ADMINISTRATOR: "ERT_Administrator",
};
